import Glide from "@glidejs/glide";
import $ from "jquery";

$(() => {
  const carousels = $(".callout-carousel");
  if (carousels.length) {
    carousels.each((i, carouselEl) => {
      const carousel = $(carouselEl);
      const glide = new Glide(carousel.find(".glide")[0], {
        rewind: false,
        gap: 16,
      });
      glide.mount();
      glide.on("resize", () => {
        // console.log(getGap(), getPerView());
        // glide.update({ perView: getPerView(), focusAt: getFocusAt() });
      });
    });
  }  
});
